export default {"src":"https://bounce.com/_next/static/media/logo-with-text-white.41e39059.svg","height":222,"width":1000,"blurWidth":0,"blurHeight":0};